const RECS_REQUEST_ID_FRAGMENT_KEY = "recsreqid";
const FEATURE_REF_FRAGMENT_KEY = "featureref1";

export const addRecsRequestIdToUrl = (url, requestId) => {
  const fragmentParameter = `${RECS_REQUEST_ID_FRAGMENT_KEY}-${encodeURIComponent(
    requestId,
  )}`;
  const hashIndex = url.indexOf("#");

  if (hashIndex === -1) {
    return `${url}#${fragmentParameter}`;
  }

  const base = url.slice(0, hashIndex);
  const fragment = url.slice(hashIndex + 1);
  const fragmentParameters = fragment ? fragment.split("&") : [];
  // featureref1 stays last: it is the final fragment parameter everywhere
  // else today and some parsers read it to the end of the fragment
  const featureRefIndex = fragmentParameters.findIndex((parameter) =>
    parameter.startsWith(`${FEATURE_REF_FRAGMENT_KEY}-`),
  );

  if (featureRefIndex === -1) {
    fragmentParameters.push(fragmentParameter);
  } else {
    fragmentParameters.splice(featureRefIndex, 0, fragmentParameter);
  }

  return `${base}#${fragmentParameters.join("&")}`;
};
